import {
    SET_ITEMS_CREATION_FORM_IS_FOCUSED,
    SET_ITEMS_CREATION_FORM_IS_EMPTY
} from '../constants/actionTypes'


export const setItemsCreationFormIsFocused = (isFocused) => ({
    type: SET_ITEMS_CREATION_FORM_IS_FOCUSED,
    isFocused
})

export const setItemsCreationFormIsEmpty = (isEmpty) => ({
    type: SET_ITEMS_CREATION_FORM_IS_EMPTY,
    isEmpty
})
